import KC_Button from "../../../../designsystem/KC_Button/KC_Button";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import { tt } from "../../../../utils/i18n/i18n";
import React from "react";

interface Props {
  onClick?: () => void;
}

export function CarouselAddPrizeButton(props: Props) {
  return (
    <div className="d-flex flex-column">
      <div className="gift-select-btn-placeholder" />
      <KC_Button
        id="add-gift"
        key="add-gift-btn"
        isTransparent={true}
        showIconOnTheLeft={true}
        icon={faPlus}
        text={
          <KC_UIText
            weight={KC_Weights.bold}
            text={tt("jp_add_gift_btn_text")}
          />
        }
        onClick={props.onClick}
        className="add-btn d-flex p-0"
      />
    </div>
  );
}
